import { IndividualListScreen } from '../features/individuals/screens/IndividualListScreen';

export const IndividualListPage = () => {
  return <IndividualListScreen />;
};
